import axios from 'axios';
import { API_url } from '../api.setup';
import { SalesPartnerBankAccountsModel, SalesPartnerBankAccountsRequestModel, SalesPartnerBankAccountTypesModel } from 'src/models/salesPartner/SalesPartnerBankAccountModel';


const API_Controller = '/SalesPartnerBankAccount';

export const SalesPartnerBankAccountsServices = {
  getAllData: async (salesPartnerId: number) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/getSalesPartnerBankAccountBySalesPartnerId?salesPartnerId=${salesPartnerId}`
      );
      return response.data as SalesPartnerBankAccountsModel[];
    } catch (error) {
      throw error;
    }
  },

  getBankAccountTypes: async () => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/getAccountTypes`
      );
      return response.data as SalesPartnerBankAccountTypesModel[];
    } catch (error) {
      throw error;
    }
  },

  addData: async (data: SalesPartnerBankAccountsModel) => {
    const remod: SalesPartnerBankAccountsRequestModel = {
      id: data.id,
      accountName: data.accountName,
      accountNumber: data.accountNumber,
      bankName: data.bankName,
      ifscCode: data.ifscCode,
      micrCode: data.micrCode,
      salesPartnerId: data.salesPartner.id,
      accountTypeId: data.accountTypeId,
      isActive: data.isActive
    };
    try {
      const response = await axios.post(`${API_url}${API_Controller}`, remod);
      return response.data as SalesPartnerBankAccountsModel;
    } catch (error) {
      throw error;
    }
  },

  updateData: async (data: any) => {
    const remod = {
      id: data.id,
      accountName: data.accountName,
      accountNumber: data.accountNumber,
      bankName: data.bankName,
      ifscCode: data.ifscCode,
      micrCode: data.micrCode,
      salesPartnerId: data.salesPartnerId,
      accountTypeId: data.accountTypeId,
      isActive: data.isActive
    };
    try {
      const response = await axios.put(
        `${API_url}${API_Controller}/update`,
        remod
      );
      return response.data as SalesPartnerBankAccountsModel;
    } catch (error) {
      throw error;
    }
  },

  deleteData: async (baId: number) => {
    try {
      const response = await axios.delete(
        `${API_url}${API_Controller}/delete?id=${baId}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
